import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAnnouncementPopupList, getAnnouncementUserView, getRealAttachmentUrl, postAnnouncementCallback } from '@/api/manageCenter';
export default {
  name: 'AnnouncementPopup',
  props: {
    // dialog 弹框 | drawer 侧滑；弹框模式公告总数仅 1 条时隐藏左侧列表
    mode: {
      type: String,
      default: 'dialog'
    },
    // 列表请求函数：弹框 /orders/annc/popup；侧滑 /orders/annc/my-list
    fetchApi: {
      type: Function,
      default: getAnnouncementPopupList
    },
    // 列表请求参数：侧滑传 { tab }，弹框无需参数；分页参数由组件内部维护
    listParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      listLoading: false,
      detailLoading: false,
      list: [],
      page: 1,
      pagesize: 20,
      pages: {},
      // 当前选中公告 id
      selectedId: null,
      detail: {},
      // 回执：请求中 loading，成功后置灰
      callbackLoading: false,
      callbackDone: false
    };
  },
  computed: {
    // 弹框模式且仅 1 条数据：不展示左侧列表，右侧详情占满
    showListPane: function showListPane() {
      return !(this.mode === 'dialog' && this.list.length === 1);
    },
    // 实际请求参数：父组件参数 + 内部分页参数
    requestParams: function requestParams() {
      return _objectSpread(_objectSpread({}, this.listParams), {}, {
        page: this.page,
        pagesize: this.pagesize
      });
    },
    // 回执栏展示条件：需要回执且未回执（is_callback 为字符串 '1'）
    showCallbackBar: function showCallbackBar() {
      return this.detail.is_callback == 1;
    }
  },
  watch: {
    // 父组件切换 tab 时参数变化：重置页码、清空右侧详情（不做默认展示）并重新拉取列表
    listParams: {
      deep: true,
      handler: function handler() {
        this.page = 1;
        this.clearDetail();
        this.getList();
      }
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    // 供父组件在打开载体后手动刷新
    refresh: function refresh() {
      this.getList();
    },
    // 左侧列表：弹框 /orders/annc/popup；侧滑 /orders/annc/my-list
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      this.fetchApi(this.requestParams).then(function (res) {
        var data = res.data || {};
        _this.list = Array.isArray(data) ? data : data.list || [];
        // 同步分页信息
        _this.pages = res.pages;
        // 弹框模式仅 1 条：无左侧列表，静默自动展示该条详情；多于 1 条不做默认选中
        if (_this.mode === 'dialog' && _this.list.length === 1) {
          _this.selectedId = _this.list[0].id;
          _this.getDetail(_this.list[0].id);
        }
        // 通知父组件加载完成（用于同步 tab 数量等）
        _this.$emit('loaded', res);
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    // 分页切换：更新页码后重新拉取列表
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    // 清空选中态与右侧详情：切换 tab 后右侧保持空态，不默认展示
    clearDetail: function clearDetail() {
      this.selectedId = null;
      this.detail = {};
      this.callbackLoading = false;
      this.callbackDone = false;
    },
    // 点击左侧条目：切换右侧详情
    handleSelect: function handleSelect(item) {
      if (this.selectedId === item.id) return;
      this.selectedId = item.id;
      this.getDetail(item.id);
    },
    // 右侧详情：/orders/annc/user-view，入参 id
    getDetail: function getDetail(id) {
      var _this2 = this;
      this.detailLoading = true;
      this.detail = {};
      // 切换公告时重置回执状态
      this.callbackLoading = false;
      this.callbackDone = false;
      getAnnouncementUserView({
        id: id
      }).then(function (res) {
        _this2.detail = res.data || {};
        // 查看详情即已读：本地去掉左侧红点并同步统计数量，不重新拉取列表（切 tab 时再拉）
        if (_this2.detail.is_callback != 1) {
          _this2.emitReadStat(id);
        }
      }).catch(function () {
        _this2.detail = {};
      }).finally(function () {
        _this2.detailLoading = false;
      });
    },
    // 本地把列表项标记为已读（去掉红点），返回之前是否未读；后端字段可能为 1/'1'/true，统一宽松比较
    markItemRead: function markItemRead(id) {
      var item = this.list.find(function (it) {
        return it.id === id;
      });
      if (!item || item.is_unread != 1) return false;
      item.is_unread = 0;
      return true;
    },
    // 查看详情已读后上报统计变化：未读数 -1；
    // 需要回执的公告已读后仍未回执、继续留在「未读/未回执」统计内，无需回执的公告已读即移出
    emitReadStat: function emitReadStat(id) {
      if (!this.markItemRead(id)) return;
      this.$emit('stat-change', {
        unreadDelta: -1,
        unCallbackDelta: 0,
        pendingDelta: this.detail.is_callback == 1 ? 0 : -1
      });
    },
    // 通过 key 换取附件真实地址，返回地址或空（异常由全局拦截器统一提示）；
    // annc_id 供后端记录附件阅读时间（回执明细展示）
    fetchAttachmentUrl: function fetchAttachmentUrl(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getRealAttachmentUrl({
                keys: [item.key],
                annc_id: _this3.detail.id
              });
            case 1:
              res = _context.v;
              return _context.a(2, res.data && res.data[0]);
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }))();
    },
    // 点击文件名：预览，获取真实地址后新窗口打开，由浏览器按文件类型展示
    handlePreview: function handlePreview(item) {
      this.fetchAttachmentUrl(item).then(function (url) {
        if (url) window.open(url);
      });
    },
    // 点击下载：获取真实地址后以原文件名保存；跨域受限时降级为新窗口打开
    handleDownload: function handleDownload(item) {
      this.fetchAttachmentUrl(item).then(function (url) {
        if (!url) return;
        fetch(url).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var downloadUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = downloadUrl;
          link.download = item.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(downloadUrl);
        }).catch(function () {
          window.open(url);
        });
      });
    },
    // 稍后处理：仅弹框模式展示；通知父载体关闭
    handleLater: function handleLater() {
      this.$emit('close');
    },
    // 我已知晓：调用回执接口；请求中 loading，成功后置灰（按钮已 disabled，无需重复拦截）
    handleCallback: function handleCallback() {
      var _this4 = this;
      this.callbackLoading = true;
      postAnnouncementCallback({
        id: this.detail.id
      }).then(function () {
        _this4.callbackDone = true;
        _this4.$message.success('回执成功');
        // 回执即已读：本地去掉左侧红点，未回执与未处理统计 -1，不重新拉取列表（切 tab 时再拉）
        var wasUnread = _this4.markItemRead(_this4.detail.id);
        _this4.$emit('callback-success', _this4.detail.id);
        _this4.$emit('stat-change', {
          unreadDelta: wasUnread ? -1 : 0,
          unCallbackDelta: -1,
          pendingDelta: -1
        });
      }).catch(function () {
        // 请求异常已由全局拦截器统一提示，此处兜底避免未处理的 Promise 拒绝
      }).finally(function () {
        _this4.callbackLoading = false;
      });
    },
    // 标签样式：按后端返回颜色渲染
    tagStyle: function tagStyle(color) {
      if (!color) return {};
      return {
        color: color,
        borderColor: color,
        backgroundColor: this.hexToRgba(color, 0.1)
      };
    },
    hexToRgba: function hexToRgba(hex, alpha) {
      var match = String(hex).match(/^#?([0-9a-fA-F]{6})$/);
      if (!match) return hex;
      var num = parseInt(match[1], 16);
      var r = num >> 16 & 255;
      var g = num >> 8 & 255;
      var b = num & 255;
      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    }
  }
};